/* eslint-disable no-use-before-define,no-mixed-operators */
import React from 'react'
import { useOrderTicket, MODES } from '../use-order-ticket.js'
import {
    iconLabel,
    icons,
    getConfig,
    publish,
    getBrand,
    getId,
    fmt,
    Flyout,
    showModal,
    cleanObject,
    preventDefaultEventsFn,
    getOwaTcdaoContext
} from '../../twd'

export const Quantity = () => {
    const {qty, setQty, price, priceOrYield, yld, action,
        orderInfo, mode, cusip, hasMarket, isRfq,
        errors, hasBondInfo, positionsTotalQty,
        bondInfo, isRestricted, isTreasuryAuction
    } = useOrderTicket()

    const canTrade = hasBondInfo && !isRestricted
    const isLift = mode===MODES.ORDER_Z
    const isDisabled = !canTrade
    const isReadOnly = isLift

    const id = getId()
    const err = !isReadOnly && !isRestricted && errors && errors.qty

    const inputRef = React.useRef(null)
    React.useEffect(preventDefaultEventsFn(inputRef, ['wheel-on-number-input']), [])

    return <React.Fragment>
        <div className="from-group"
            style={{paddingLeft:'0px', paddingRight:'0px'}}
        >
            <div style={{display:'flex', flexDirection:'row', flexWrap:'nowrap', justifyContent:'space-between'}}>
            <div><Flyout
                label="Quantity"
                labelAttrs={{htmlFor:id}}
                isLabel={true}
                html={QuantityTooltip}
            /></div>
            <div>{!isTreasuryAuction && <button
                style={{minHeight:'20px'}}
                data-name="bond-detail-bond-offerings-price-yield-calculator"
                className="link-button"
                onClick={() => {

                    const best = (hasBondInfo && bondInfo.bestoffer) || {}
                    const off = (action === 'B' || action==='F') ? best.ask : best.bid
                    const pxType = off ? '1' : priceOrYield
                    const px = pxType==='1'
                        ? (off && off.price || price || 100)
                        : yld

                    if (getConfig('entitlements.ETradeCalculator', 'No') === 'Yes') {
                        showModal(cleanObject({
                            view: 'calculator',
                            cusip: cusip,
                            from: 'order-ticket',
                            // action: (action === 'B' || action==='F') ? 'B' : 'S',
                            // price: price || (off && off.price) || 100,
                            // yld,
                            // priceOrYield,
                            // qty: qty || (off && off.quantity) || null,
                        }))
                        return
                    }

                    let base = getConfig('bw_service_host') + '/' + getBrand()
                    let sp = new URLSearchParams()

                    sp.set('p_javascript', 2)
                    sp.set('p_data_source', off && off.id ? 'I' : 'D')
                    sp.set('p_id', off && off.id || cusip)
                    sp.set('p_price_type', pxType)
                    sp.set('p_price', px)
                    sp.set('p_quantity', off && off.quantity || qty || 0)
                    sp.set('p_commission', '')
                    sp.set('p_ts', Date.now())

                    let owaTcDaoContext = getOwaTcdaoContext()
                    let url = `${base}/${owaTcDaoContext}/pkg_calc_bond_online.seed?${sp.toString()}`

                    publish('open', {
                        url,
                        name: '_blank',
                        options: "toolbar=no,width=760,height=490,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no"
                    })
                }}
                >
                { iconLabel(icons.calculate, 'Price/yield calculator') }
            </button>}</div>
            </div>
            <div className={err ? ' has-error' : ''}>
                <div className="input-group vertical-offset-xxs" >
                <input
                    type="number"
                    id={id}
                    ref={inputRef}
                    className='form-control'
                    value={qty}
                    readOnly={isReadOnly}
                    aria-readonly={isReadOnly}
                    disabled={isDisabled || isReadOnly}
                    step="1"
                    min="0"
                    style={{paddingLeft:'20px'}}
                    onChange={(e) =>{
                        setQty(e.target.value || '')
                    }}
                    />
                <label className="input-group-addon text-body">,000</label>
                </div>
            { err && <label className="field-status has-error">{err}</label> }
            </div>
        </div>

        {cusip && !isRfq && (hasMarket || isTreasuryAuction) && !isLift && (() => {
            const { qty_min, qty_max } = orderInfo
            return <div>
                Min: {fmt.qty(qty_min)}
                {qty_max && <React.Fragment> - Max: {fmt.qty(qty_max)}</React.Fragment>}
            </div>
        })()}

        {cusip && <div>Total position: {fmt.qty(positionsTotalQty)}</div>}

    </React.Fragment>
}

const QuantityTooltip = `
    Utilize the variable quantity field to input the number of bonds you wish to buy or sell.
    For buy and sell orders, the quantity range displayed below the input field represents the minimum
    and maximum quantity available from the offering dealer.
    Entering a quantity below the dealer minimum or exceeding the dealer maximum will cause a bond order to convert
    into a quote request.
    The “My total position:” (displayed below the input field after a bond is loaded into the ticket)
    represents the number of bonds held in the active account for the CUSIP shown.
`